// extracted by mini-css-extract-plugin
export var shake = "_9-0";